import { render, staticRenderFns } from "./SinopticoAparcamiento.vue?vue&type=template&id=5674f990&scoped=true&"
import script from "./SinopticoAparcamiento.vue?vue&type=script&lang=js&"
export * from "./SinopticoAparcamiento.vue?vue&type=script&lang=js&"
import style0 from "./SinopticoAparcamiento.vue?vue&type=style&index=0&id=5674f990&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5674f990",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardText,VCardTitle,VCol,VContainer,VIcon,VProgressCircular,VRow,VSelect})
